import React, { useState, useEffect, useRef } from "react";
import "./Marketing.css";
import TopRightActionLinks from "../../TopRightActionLinks";
import InsightBlock from "../../InsightBlock";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../../context/UserContext";
import { useDispatch, useSelector } from "react-redux";
import {
  submitCompetitorProfileFailure,
  submitCompetitorProfileRequest,
} from "../../../../../store/features/actions/competitorProfileActions";
import { submitCompetitorProfileV3Request } from "../../../../../store/features/actions/competitorProfileV3Actions";
import {
  getAllSubdimensionMatches,
  getAllDynamicSubdimensionMatches,
  getAllPageInsights,
  formatBoldText,
  getCompProfilePageInsights,
  hasData,
} from "../../../../../services/commonService";
import useDynamicSubtabs from "../../../../../hooks/useDynamicSubtabs";
import useDynamicTableExport from "../../../../../hooks/useDynamicTableExport";
import useActiveScrollSection from "../../../../../hooks/useActiveScrollSection";
import GtmModel from "./GtmModel";
import Pricing from "./Pricing";
import CustomerSegments from "./CustomerSegments";
import TopCustomers from "./TopCustomers";
import * as FeatherIcon from "react-feather";
import WorldHeatmap from "../../../../HtmlElements/WorldHeatmap";
import GroupedColumnChart from "../../../../HtmlElements/GroupedColumnChart";
import DistributionNetworksAndPartnerships from "./DistributionNetworksAndPartnerships";
import ChannelMixAndUtilization from "./ChannelMixAndUtilization";
import DemandGenerationAndAcquisistionTactics from "./DemandGenerationAndAcquisistionTactics";
import MarketingInvestmentAndROISignals from "./MarketingInvestmentAndROISignals";
import MarketPresenceAndBrandSignals from "./MarketPresenceAndBrandSignals";
import MessagingAndPositioning from "./MessagingAndPositioning";
import DigitalFootprintAnalysis from "./DigitalFootprintAnalysis";
import AdvertisingAndMediaSpend from "./AdvertisingAndMediaSpend";
import MarketingChannelsBySegment from "./MarketingChannelsBySegment";
import MarketingGeographicCoverage from "./MarketingGeographicCoverage";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../../Chat/AiChat";
import GenericTableSkeleton from "../../../skeletons/tableSkeleton/genericTableSkeleton";
import APP_CONFIG from "../../../../../config/appConfig";

function Marketing({
  activeSubKey,
  setActiveSubKey,
  compView,
  dataReportCheck,
  scrollTarget,
  marketIqClient,
  clientCompanyType,
  existingSubdimensions,
  subdimensionStatus,
  registerDynamicTabs,
}) {
  const { user } = useUser();
  const { exportTableToCSV } = useDynamicTableExport();
  const insightSummaryRef = useRef(null);
  const gtmModelRef = useRef(null);
  const distributionNetworksPartnershipsRef = useRef(null);
  const channelMixUtilizationRef = useRef(null);
  const demandGenerationAcquisitionTacticsRef = useRef(null);
  const marketingInvestmentROISignalsRef = useRef(null);
  const marketPresenceBrandSignalsRef = useRef(null);
  const messagingPositioningRef = useRef(null);
  const digitalFootprintAnalysisRef = useRef(null);
  const advertisingMediaSpendRef = useRef(null);
  const marketingChannelsbySegmentRef = useRef(null);
  const marketingGeographicCoverageRef = useRef(null);
  const programmaticScrollRef = useRef(false);
  const dynamicRefs = useRef({});
  const containerRef = useRef(null);
  const [dynamicReady, setDynamicReady] = useState(0);
  const sectionMap = {
    insightSummaryTabM: insightSummaryRef,
    gtmModelTab: gtmModelRef,
    distributionNetworksPartnershipsTab: distributionNetworksPartnershipsRef,
    channelMixUtilizationTab: channelMixUtilizationRef,
    demandGenerationAcquisitionTacticsTab:
      demandGenerationAcquisitionTacticsRef,
    marketingInvestmentROISignalsTab: marketingInvestmentROISignalsRef,
    marketPresenceBrandSignalsTab: marketPresenceBrandSignalsRef,
    messagingPositioningTab: messagingPositioningRef,
    digitalFootprintAnalysisTab: digitalFootprintAnalysisRef,
    advertisingMediaSpendTab: advertisingMediaSpendRef,
    marketingChannelsbySegmentTab: marketingChannelsbySegmentRef,
    marketingGeographicCoverageTab: marketingGeographicCoverageRef,
    ...Object.fromEntries(
      Object.entries(dynamicRefs.current).map(([key, el]) => [
        key,
        { current: el },
      ])
    ),
  };

  // useActiveScrollSection(
  //   sectionMap,
  //   activeSubKey,
  //   setActiveSubKey,
  //   programmaticScrollRef
  // );

  const { showScrollTop, scrollToTop } = useActiveScrollSection(
    sectionMap,
    activeSubKey,
    setActiveSubKey,
    programmaticScrollRef,
    dynamicReady, // NEW
    containerRef // NEW
  );

  const [dynamicSubdimension, setDynamicSubdimension] = useState([]);
  useDynamicSubtabs({
    parentKey: "marketing",
    sourceData: dynamicSubdimension,
    registerDynamicTabs,
    keyPrefix: "dynamic_marketing",
  });

  // const scrollToSection = (key) => {
  //   const ref = sectionMap[key];
  //   if (!ref?.current) return;

  //   programmaticScrollRef.current = true;

  //   const yOffset = -100;
  //   const y =
  //     ref.current.getBoundingClientRect().top + window.scrollY + yOffset;

  //   window.scrollTo({ top: y, behavior: "smooth" });

  //   setTimeout(() => {
  //     programmaticScrollRef.current = false;
  //   }, 700);
  // };

  const scrollToSection = (key) => {
    const staticRef = sectionMap[key];

    if (staticRef?.current) {
      staticRef.current.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
      return;
    }

    const dynamicEl = dynamicRefs.current[key];

    if (dynamicEl) {
      dynamicEl.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
    }
  };

  const [showConversationModal, setShowConversationModal] = useState(false);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const [gtmModel, setGtmModel] = useState([]);
  const [
    demandGenerationAndAcquisitionTactics,
    setDemandGenerationAndAcquisitionTactics,
  ] = useState([]);
  const [
    marketingInvestmentsAndRoiSignals,
    setMarketingInvestmentsAndRoiSignals,
  ] = useState([]);
  const { clientName, competitorName } = useParams();
  const [marketPresenceAndBrandSignals, setMarketPresenceAndBrandSignals] =
    useState([]);

  const [messagingAndPositioning, setMessagingAndPositioning] = useState([]);
  const [digitalFootprintAnalysis, setDigitalFootprintAnalysis] = useState([]);
  const [advertisingAndMediaSpend, setAdvertisingAndMediaSpend] = useState([]);
  const [marketingChannelsBySegment, setMarketingChannelsBySegment] = useState(
    []
  );
  const [marketingGeographicCoverage, setMarketingGeographicCoverage] =
    useState([]);

  const existingSubs = existingSubdimensions?.data || [];
  const useExistingSubdimensions = existingSubs.length > 0;

  const normalize = (str) => str?.toLowerCase().replace(/[_\s]/g, "");

  const subdimensionExists = (name) => {
    // fallback if API not available
    if (!useExistingSubdimensions) return true;

    return existingSubs.some((s) => normalize(s) === normalize(name));
  };

  const getSubdimensionStatus = (name) => {
    if (!subdimensionStatus) return "complete";

    const { added = [], update_in_progress = [] } = subdimensionStatus;

    const isGenerating =
      added.some((s) => normalize(s) === normalize(name)) ||
      update_in_progress.some((s) => normalize(s) === normalize(name));

    return isGenerating ? "generating" : "complete";
  };

  const GeneratingSkeleton = () => (
    <GenericTableSkeleton colCount={3} rowCount={5} />
  );

  const [marketingDataCheck, setMarketingDataCheck] = useState({
    hasInsightSummaryTabMData: true,
    hasGtmModelTabData: true,
    hasDistributionNetworksPartnershipsTabData: true,
    hasChannelMixUtilizationTabData: true,
    hasDemandGenerationAcquisitionTacticsTabData: true,
    hasMarketingInvestmentROISignalsTabData: true,
    hasMarketPresenceBrandSignalsTabData: true,
    hasMessagingPositioningTabData: true,
    hasDigitalFootprintAnalysisTabData: true,
    hasAdvertisingMediaSpendTabData: true,
    hasMarketingChannelsbySegmentTabData: true,
    hasMarketingGeographicCoverageTabData: true,
  });

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // {
    //   type: "conversation",
    //   title: "Conversation",
    //   onClick: () => {
    //     setShowConversationModal((prev) => !prev);
    //   },
    // },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    // { type: "download", title: "Download", onClick: () => {} },
  ];

  const dispatch = useDispatch();
  // const { loading, data, error } = useSelector(
  //   (state) => state.competitorProfileReducer
  // );

  const { loading, data, error } = useSelector(
    (state) => state.competitorProfileV3Reducer
  );

  // Scroll into view when a subsection tab is clicked
  // useEffect(() => {
  //   if (!activeSubKey) return;
  //   const sectionMap = {
  //     insightSummaryTab: insightSummaryRef,
  //     gtmModelTab: gtmModelRef,
  //     distributionNetworksPartnershipsTab: distributionNetworksPartnershipsRef,
  //     channelMixUtilizationTab: channelMixUtilizationRef,
  //     demandGenerationAcquisitionTacticsTab:
  //       demandGenerationAcquisitionTacticsRef,
  //     marketingInvestmentROISignalsTab: marketingInvestmentROISignalsRef,
  //     marketPresenceBrandSignalsTab: marketPresenceBrandSignalsRef,
  //     messagingPositioningTab: messagingPositioningRef,
  //     digitalFootprintAnalysisTab: digitalFootprintAnalysisRef,
  //     advertisingMediaSpendTab: advertisingMediaSpendRef,
  //     marketingChannelsbySegmentTab: marketingChannelsbySegmentRef,
  //     marketingGeographicCoverageTab: marketingGeographicCoverageRef,
  //   };

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });
  //   }
  // }, [activeSubKey]);

  // useEffect(() => {
  //   if (!activeSubKey) return;

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     // mark as programmatic scroll so scroll-spy ignores this movement
  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     // clear the flag after animation; tune timeout to match your animation time
  //     const t = setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);

  //     return () => clearTimeout(t);
  //   }
  // }, [activeSubKey]);

  useEffect(() => {
    if (!activeSubKey) return;
    scrollToSection(activeSubKey);
  }, [activeSubKey]);

  // +++++++++++++++++++++++++++++++++++++++++++++
  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // useEffect(() => {
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       const scrollPosition = window.scrollY + 120; // offset to trigger slightly earlier
  //       let currentKey = null;

  //       Object.entries(sectionMap).forEach(([key, ref]) => {
  //         if (!ref.current) return;
  //         const sectionTop = ref.current.offsetTop;
  //         if (scrollPosition >= sectionTop) {
  //           currentKey = key;
  //         }
  //       });

  //       // update parent only if different
  //       if (currentKey && currentKey !== activeSubKey) {
  //         setActiveSubKey(currentKey);
  //       }
  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   // trigger once on mount to set correct nav if already scrolled
  //   handleScroll();

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [activeSubKey, setActiveSubKey]);

  // useEffect(() => {
  //   let scrollTimeout = null;
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       // Clear previous timeout (debounce)
  //       if (scrollTimeout) clearTimeout(scrollTimeout);

  //       // Wait until user stops scrolling for 200ms
  //       scrollTimeout = setTimeout(() => {
  //         const scrollPosition = window.scrollY + 120; // offset for header, etc.
  //         let currentKey = null;

  //         Object.entries(sectionMap).forEach(([key, ref]) => {
  //           if (!ref.current) return;
  //           const sectionTop = ref.current.offsetTop;
  //           const sectionHeight = ref.current.offsetHeight;

  //           // Check if scroll is within this section
  //           if (
  //             scrollPosition >= sectionTop &&
  //             scrollPosition < sectionTop + sectionHeight
  //           ) {
  //             currentKey = key;
  //           }
  //         });

  //         // update nav only if different
  //         if (currentKey && currentKey !== activeSubKey) {
  //           setActiveSubKey(currentKey);
  //         }
  //       }, 200); // change nav only after 200ms of no scrolling

  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });

  //   // run once on mount
  //   handleScroll();

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //     if (scrollTimeout) clearTimeout(scrollTimeout);
  //   };
  // }, [activeSubKey, setActiveSubKey]);

  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // +++++++++++++++++++++++++++++++++++++++++++++

  const formData = {
    dimension: "Marketing",
    client: clientName ?? "HB Fuller",
    company: competitorName ?? "Tailored Chemical Products",
    user_id: user?.user_id,
    user_role: user?.growth_iq_role_name,
    user_type:
      user?.demo === APP_CONFIG?.market_iq_demo ? "MarketIQ" : "CompIQ",
  };
  useEffect(() => {
    // dispatch(submitCompetitorProfileRequest("MarketingDistribution"));
    // dispatch(submitCompetitorProfileRequest("Marketing"));
    dispatch(submitCompetitorProfileV3Request(formData));
  }, []);

  const chartData = [
    { year: "2019", gross: 25, operating: 14, net: 9 },
    { year: "2020", gross: 25, operating: 14, net: 9 },
    { year: "2021", gross: 25, operating: 14, net: 9 },
    { year: "2022", gross: 25, operating: 14, net: 9 },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  useEffect(() => {
    const tempDynamicSubdimension = getAllDynamicSubdimensionMatches(data, [
      "GTM & Distribution Strategy Analysis",
      "Demand Generation & Acquisition Tactics",
      "Marketing Investment & ROI Signals",
      "Market Presence & Brand Signals",
      "Messaging & Positioning",
      "Digital Footprint Analysis",
      "Advertising & Media Spend",
      "Marketing Channels by Segment",
      "Marketing Geographic Coverage",
    ]);
    setDynamicSubdimension(tempDynamicSubdimension);

    const tempGtmModel = getAllSubdimensionMatches(
      data,
      "GTM & Distribution Strategy Analysis"
    );
    setGtmModel(tempGtmModel);

    const tempDemandGenerationAndAcquisitionTactics = getAllSubdimensionMatches(
      data,
      "Demand Generation & Acquisition Tactics"
    );
    setDemandGenerationAndAcquisitionTactics(
      tempDemandGenerationAndAcquisitionTactics
    );

    const tempMarketingInvestmentAndRoiSignals = getAllSubdimensionMatches(
      data,
      "Marketing Investment & ROI Signals"
    );
    setMarketingInvestmentsAndRoiSignals(tempMarketingInvestmentAndRoiSignals);

    const tempMarketPresenceAndBrandSignals = getAllSubdimensionMatches(
      data,
      "Market Presence & Brand Signals"
    );
    setMarketPresenceAndBrandSignals(tempMarketPresenceAndBrandSignals);

    const tempMessagingAndPositioning = getAllSubdimensionMatches(
      data,
      "Messaging & Positioning"
    );
    setMessagingAndPositioning(tempMessagingAndPositioning);

    const tempDigitalFootprintAnalysis = getAllSubdimensionMatches(
      data,
      "Digital Footprint Analysis"
    );
    setDigitalFootprintAnalysis(tempDigitalFootprintAnalysis);

    const tempAdvertisingAndMediaSpend = getAllSubdimensionMatches(
      data,
      "Advertising & Media Spend"
    );
    setAdvertisingAndMediaSpend(tempAdvertisingAndMediaSpend);

    const tempMarketingChannelsBySegment = getAllSubdimensionMatches(
      data,
      "Marketing Channels by Segment"
    );
    setMarketingChannelsBySegment(tempMarketingChannelsBySegment);

    const tempMarketingGeographicCoverage = getAllSubdimensionMatches(
      data,
      "Marketing Geographic Coverage"
    );
    setMarketingGeographicCoverage(tempMarketingGeographicCoverage);

    const { positive, negative, sowhat } = getCompProfilePageInsights(data);
    setPagePositives(formatBoldText(positive) || []);
    setPageNegatives(formatBoldText(negative) || []);
    setPageSoWhat(formatBoldText(sowhat) || []);

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasInsightSummaryTabMData: !!(positive || negative || sowhat),
    // }));

    // dataReportCheck(
    //   "insightSummaryTabM",
    //   marketingDataCheck.hasInsightSummaryTabMData
    // );

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasGtmModelTabData: !!gtmModel,
    // }));

    // dataReportCheck("gtmModelTab", marketingDataCheck.hasGtmModelTabData);

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasDistributionNetworksPartnershipsTabData: !!gtmModel,
    // }));

    // dataReportCheck(
    //   "distributionNetworksPartnershipsTab",
    //   marketingDataCheck.hasDistributionNetworksPartnershipsTabData
    // );

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasChannelMixUtilizationTabData: !!gtmModel,
    // }));

    // dataReportCheck(
    //   "channelMixUtilizationTab",
    //   marketingDataCheck.hasChannelMixUtilizationTabData
    // );

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasDemandGenerationAcquisitionTacticsTabData:
    //     !!demandGenerationAndAcquisitionTactics,
    // }));

    // dataReportCheck(
    //   "demandGenerationAcquisitionTacticsTab",
    //   marketingDataCheck.hasDemandGenerationAcquisitionTacticsTabData
    // );

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasMarketingInvestmentROISignalsTabData:
    //     !!marketingInvestmentsAndRoiSignals,
    // }));

    // dataReportCheck(
    //   "marketingInvestmentROISignalsTab",
    //   marketingDataCheck.hasMarketingInvestmentROISignalsTabData
    // );

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasMarketPresenceBrandSignalsTabData: !!marketPresenceAndBrandSignals,
    // }));

    // dataReportCheck(
    //   "marketPresenceBrandSignalsTab",
    //   marketingDataCheck.hasMarketPresenceBrandSignalsTabData
    // );

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasMessagingPositioningTabData: !!messagingAndPositioning,
    // }));

    // dataReportCheck(
    //   "messagingPositioningTab",
    //   marketingDataCheck.hasMessagingPositioningTabData
    // );

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasDigitalFootprintAnalysisTabData: !!digitalFootprintAnalysis,
    // }));

    // dataReportCheck(
    //   "digitalFootprintAnalysisTab",
    //   marketingDataCheck.hasDigitalFootprintAnalysisTabData
    // );

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasAdvertisingMediaSpendTabData: !!advertisingAndMediaSpend,
    // }));

    // dataReportCheck(
    //   "advertisingMediaSpendTab",
    //   marketingDataCheck.hasAdvertisingMediaSpendTabData
    // );

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasMarketingChannelsbySegmentTabData: !!marketingChannelsBySegment,
    // }));

    // dataReportCheck(
    //   "marketingChannelsbySegmentTab",
    //   marketingDataCheck.hasMarketingChannelsbySegmentTabData
    // );

    // setMarketingDataCheck((prevState) => ({
    //   ...prevState,
    //   hasMarketingGeographicCoverageTabData: !!marketingGeographicCoverage,
    // }));

    // dataReportCheck(
    //   "marketingGeographicCoverageTab",
    //   marketingDataCheck.hasMarketingGeographicCoverageTabData
    // );

    const newChecks = {
      hasInsightSummaryTabMData:
        hasData(positive) || hasData(negative) || hasData(sowhat),
      hasGtmModelTabData: hasData(tempGtmModel),
      hasDistributionNetworksPartnershipsTabData: hasData(tempGtmModel),
      hasChannelMixUtilizationTabData: hasData(tempGtmModel),
      hasDemandGenerationAcquisitionTacticsTabData: hasData(
        tempDemandGenerationAndAcquisitionTactics
      ),
      hasMarketingInvestmentROISignalsTabData: hasData(
        tempMarketingInvestmentAndRoiSignals
      ),
      hasMarketPresenceBrandSignalsTabData: hasData(
        tempMarketPresenceAndBrandSignals
      ),
      hasMessagingPositioningTabData: hasData(tempMessagingAndPositioning),
      hasDigitalFootprintAnalysisTabData: hasData(tempDigitalFootprintAnalysis),
      hasAdvertisingMediaSpendTabData: hasData(tempAdvertisingAndMediaSpend),
      hasMarketingChannelsbySegmentTabData: hasData(
        tempMarketingChannelsBySegment
      ),
      hasMarketingGeographicCoverageTabData: hasData(
        tempMarketingGeographicCoverage
      ),
    };

    setMarketingDataCheck(newChecks);

    dataReportCheck("insightSummaryTabM", newChecks.hasInsightSummaryTabMData);
    dataReportCheck("gtmModelTab", newChecks.hasGtmModelTabData);
    dataReportCheck(
      "distributionNetworksPartnershipsTab",
      newChecks.hasDistributionNetworksPartnershipsTabData
    );
    dataReportCheck(
      "channelMixUtilizationTab",
      newChecks.hasChannelMixUtilizationTabData
    );
    dataReportCheck(
      "demandGenerationAcquisitionTacticsTab",
      newChecks.hasDemandGenerationAcquisitionTacticsTabData
    );
    dataReportCheck(
      "marketingInvestmentROISignalsTab",
      newChecks.hasMarketingInvestmentROISignalsTabData
    );
    dataReportCheck(
      "marketPresenceBrandSignalsTab",
      newChecks.hasMarketPresenceBrandSignalsTabData
    );
    dataReportCheck(
      "messagingPositioningTab",
      newChecks.hasMessagingPositioningTabData
    );
    dataReportCheck(
      "digitalFootprintAnalysisTab",
      newChecks.hasDigitalFootprintAnalysisTabData
    );
    dataReportCheck(
      "advertisingMediaSpendTab",
      newChecks.hasAdvertisingMediaSpendTabData
    );
    dataReportCheck(
      "marketingChannelsbySegmentTab",
      newChecks.hasMarketingChannelsbySegmentTabData
    );
    dataReportCheck(
      "marketingGeographicCoverageTab",
      newChecks.hasMarketingGeographicCoverageTabData
    );

    // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  }, [data]);

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // HANDLE SCROLL FROM SEARCH (from parent via scrollTarget)
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // useEffect(() => {
  //   if (!scrollTarget) return;

  //   // Don't scroll if data is still loading
  //   if (loading) {
  //     console.log("⏳ Waiting for data to load...");
  //     return;
  //   }

  //   const targetKey = scrollTarget.key;
  //   const sectionRef = sectionMap[targetKey];

  //   const scrollToSection = () => {
  //     if (!sectionRef?.current) {
  //       requestAnimationFrame(scrollToSection);
  //       return;
  //     }

  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const element = sectionRef.current;
  //     const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);
  //   };

  //   // Give extra time for skeleton to disappear and content to render
  //   const timer = setTimeout(() => {
  //     requestAnimationFrame(scrollToSection);
  //   }, 1200); // Increase this if staticDataLoading timeout is 1000ms

  //   return () => clearTimeout(timer);
  // }, [scrollTarget, loading]); // ADD staticDataLoading to deps

  useEffect(() => {
    if (!scrollTarget || loading) return;

    const timer = setTimeout(() => {
      scrollToSection(scrollTarget.key);
    }, 900); // wait for skeleton + render

    return () => clearTimeout(timer);
  }, [scrollTarget, loading]);

  useEffect(() => {
    // trigger once after dynamic sections render
    if (dynamicSubdimension.length > 0) {
      const timer = setTimeout(() => {
        setDynamicReady((prev) => prev + 1);
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [dynamicSubdimension]);

  // +++++++++++++++++++++++++++++++++++++++++++++++++

  return (
    <div className="marketing_wrapper">
      <div className="marketing_headblock">
        <div className="marketing_subheadblock">
          <h5 className="marketing_head">Marketing & Distribution</h5>
          <p className="marketing_para">
            {/* Decode {competitorName ?? "Tailored Chemical Products"} GTM motion,
            pricing, partners, and customer segments to inform battlecards and
            account-level strategy. */}
            Decode {competitorName ?? "Tailored Chemical Products"} GTM motion,
            pricing, partners, and customer segments to inform battlecards and
            marketing strategy.
          </p>
        </div>
        <div className="news_position_btn_block">
          <TopRightActionLinks actions={actions} />
        </div>
      </div>

      {
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
          subdimensionExists("Strategic Analysis") &&
          (getSubdimensionStatus("Strategic Analysis") === "generating" ? (
            <>
              Data is being generated for this element...
              <GeneratingSkeleton />
            </>
          ) : (
            marketingDataCheck.hasInsightSummaryTabMData && (
              <div ref={insightSummaryRef}>
                <InsightBlock
                  title={""}
                  overview={""}
                  actions={[]}
                  pagePositives={pagePositives}
                  pageNegatives={pageNegatives}
                  pageSoWhat={pageSoWhat}
                />
              </div>
            )
          ))
      }

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("GTM & Distribution Strategy Analysis") &&
        (getSubdimensionStatus("GTM & Distribution Strategy Analysis") ===
        "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasGtmModelTabData &&
          compView !== "quantitative" && (
            <div ref={gtmModelRef}>
              <GtmModel gtmModel={gtmModel} compView={compView} />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        subdimensionExists("GTM & Distribution Strategy Analysis") &&
        (getSubdimensionStatus("GTM & Distribution Strategy Analysis") ===
        "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasDistributionNetworksPartnershipsTabData &&
          compView !== "quantitative" && (
            <div ref={distributionNetworksPartnershipsRef}>
              <DistributionNetworksAndPartnerships
                gtmModel={gtmModel}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        // Channel mix and utilization in marketing distribution tab displayed to market iq users as asked by Payal
        // clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("GTM & Distribution Strategy Analysis") &&
        (getSubdimensionStatus("GTM & Distribution Strategy Analysis") ===
        "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasChannelMixUtilizationTabData && (
            <div ref={channelMixUtilizationRef}>
              <ChannelMixAndUtilization
                gtmModel={gtmModel}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("Demand Generation & Acquisition Tactics") &&
        (getSubdimensionStatus("Demand Generation & Acquisition Tactics") ===
        "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasDemandGenerationAcquisitionTacticsTabData && (
            <div ref={demandGenerationAcquisitionTacticsRef}>
              <DemandGenerationAndAcquisistionTactics
                demandGenerationAndAcquisitionTactics={
                  demandGenerationAndAcquisitionTactics
                }
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("Marketing Investment & ROI Signals") &&
        (getSubdimensionStatus("Marketing Investment & ROI Signals") ===
        "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasMarketingInvestmentROISignalsTabData && (
            <div ref={marketingInvestmentROISignalsRef}>
              <MarketingInvestmentAndROISignals
                marketingInvestmentsAndRoiSignals={
                  marketingInvestmentsAndRoiSignals
                }
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("Market Presence & Brand Signals") &&
        (getSubdimensionStatus("Market Presence & Brand Signals") ===
        "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasMarketPresenceBrandSignalsTabData && (
            <div ref={marketPresenceBrandSignalsRef}>
              <MarketPresenceAndBrandSignals
                marketPresenceAndBrandSignals={marketPresenceAndBrandSignals}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        compView !== "quantitative" &&
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("Messaging & Positioning") &&
        (getSubdimensionStatus("Messaging & Positioning") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasMessagingPositioningTabData && (
            <div ref={messagingPositioningRef}>
              <MessagingAndPositioning
                messagingAndPositioning={messagingAndPositioning}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("Digital Footprint Analysis") &&
        (getSubdimensionStatus("Digital Footprint Analysis") ===
        "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasDigitalFootprintAnalysisTabData && (
            <div ref={digitalFootprintAnalysisRef}>
              <DigitalFootprintAnalysis
                digitalFootprintAnalysis={digitalFootprintAnalysis}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("Advertising & Media Spend") &&
        (getSubdimensionStatus("Advertising & Media Spend") === "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasAdvertisingMediaSpendTabData && (
            <div ref={advertisingMediaSpendRef}>
              <AdvertisingAndMediaSpend
                advertisingAndMediaSpend={advertisingAndMediaSpend}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        compView !== "quantitative" &&
        subdimensionExists("Marketing Channels by Segment") &&
        (getSubdimensionStatus("Marketing Channels by Segment") ===
        "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasMarketingChannelsbySegmentTabData && (
            <div ref={marketingChannelsbySegmentRef}>
              <MarketingChannelsBySegment
                marketingChannelsBySegment={marketingChannelsBySegment}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        // clientName !== marketIqClient &&
        clientCompanyType !== APP_CONFIG.market_iq_demo &&
        subdimensionExists("Marketing Geographic Coverage") &&
        (getSubdimensionStatus("Marketing Geographic Coverage") ===
        "generating" ? (
          <>
            Data is being generated for this element...
            <GeneratingSkeleton />
          </>
        ) : (
          marketingDataCheck.hasMarketingGeographicCoverageTabData && (
            <div ref={marketingGeographicCoverageRef}>
              <MarketingGeographicCoverage
                marketingGeographicCoverage={marketingGeographicCoverage}
                compView={compView}
              />
            </div>
          )
        ))
      )}

      {/* {dynamicSubdimension.map((item, index) => {
        const key = `dynamic_marketing_${index}`;

        return (
          <div key={key} ref={(el) => (dynamicRefs.current[key] = el)}>
            <h5 className="mb-4">
              {item?.response?.subdimension_name}
              <span className="dynamic-subdimension-label">
                (User generated table)
              </span>
            </h5>

            <div
              className="table-responsive dynamic-subdimension"
              dangerouslySetInnerHTML={{
                __html: item?.response?.table,
              }}
            />
          </div>
        );
      })} */}

      {dynamicSubdimension.map((item, index) => {
        const key = `dynamic_marketing_${index}`;
        const title = item?.response?.subdimension_name || "Dynamic Table";

        const actions = [
          {
            type: "download",
            title: "Export CSV",
            onClick: () => exportTableToCSV(dynamicRefs.current[key], title),
          },
        ];

        return (
          <div
            key={key}
            ref={(el) => {
              if (el) {
                dynamicRefs.current[key] = el;
              }
            }}
          >
            <div className="table_head_block mb-3" style={{ display: "flex" }}>
              <div className="table_subblock_left">
                <h5 className="table_head">
                  {title}
                  <span className="dynamic-subdimension-label">
                    (User generated table)
                  </span>
                </h5>
              </div>
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "end",
                }}
              >
                <TopRightActionLinks actions={actions} />
              </div>
            </div>

            <div
              className="table-responsive dynamic-subdimension"
              dangerouslySetInnerHTML={{
                __html: item?.response?.table,
              }}
            />
          </div>
        );
      })}

      {/* <div className="channel_partnership_wrapper">
        <div className="channel_partnership_headblock">
          <div className="channel_partnership_subheadblock">
            <h5 className="channel_partnership_head">Channel Partnerships</h5>
            <p className="channel_partnership_para">
              Key regional and global partners categorized by region and tier.
              This view helps assess the strength and spread of Siemens'
              indirect GTM model.
            </p>
          </div>
          <div className="channel_partnership_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="channel_partnership_block">
          <WorldHeatmap />
        </div>
      </div> */}

      {/* <div className="channel_contribution_wrapper">
        <div className="channel_contribution_headblock">
          <div className="channel_contribution_subheadblock">
            <h5 className="channel_contribution_head">
              Channel Contribution Mix
            </h5>
            <p className="channel_contribution_para">
              Breakdown of revenue contribution by different GTM channels. Helps
              visualize the weight of direct vs partner-led strategies across
              global markets.
            </p>
          </div>
          <div className="channel_contribution_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="channel_contribution_block">
          <GroupedColumnChart data={chartData} />
        </div>
      </div> */}

      {/* <Pricing /> */}
      {/* <CustomerSegments /> */}

      {/* <div className="voc_wrapper">
        <div className="voc_headblock">
          <div className="voc_subheadblock">
            <h5 className="voc_head">Voice of Customer (VoC)</h5>
            <p className="voc_para">
              Direct customer quotes from verified sources that reveal sentiment
              around Siemens’ pricing, onboarding, product value, and support
              experience.
            </p>
          </div>
          <div className="voc_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="voc_block_positive">
              <div className="voc_subblock_positve">
                <div className="voc_alert_block">
                  <div className="voc_icon_block">
                    <FeatherIcon.ThumbsUp className="icon" />
                  </div>
                  <div className="voc_text_block">
                    <h5 className="voc_head">
                      "Siemens delivers exceptional uptime. Our digital twin
                      deployment is now a benchmark internally."
                    </h5>
                    <div className="voc_bottom_block">
                      <div className="voc_bottom_left">
                        <p className="voc_text_para">- Digital Technology</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="voc_block_meduim">
              <div className="voc_subblock_meduim">
                <div className="voc_alert_block">
                  <div className="voc_icon_block">
                    <FeatherIcon.Meh className="icon" />
                  </div>
                  <div className="voc_text_block">
                    <h5 className="voc_head">
                      "The onboarding was smooth, but we had to push for
                      integrations with our legacy tools."
                    </h5>
                    <div className="voc_bottom_block">
                      <div className="voc_bottom_left">
                        <p className="voc_text_para">
                          – Manufacturing Lead, North America
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="voc_block_negative">
              <div className="voc_subblock_negative">
                <div className="voc_alert_block">
                  <div className="voc_icon_block">
                    <FeatherIcon.ThumbsUp className="icon" />
                  </div>
                  <div className="voc_text_block">
                    <h5 className="voc_head">
                      "Siemens delivers exceptional uptime. Our digital twin
                      deployment is now a benchmark internally."
                    </h5>
                    <div className="voc_bottom_block">
                      <div className="voc_bottom_left">
                        <p className="voc_text_para">- Digital Technology</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="strategic_accounts_wrapper">
        <div className="strategic_accounts_headblock">
          <div className="strategic_accounts_subheadblock">
            <h5 className="strategic_accounts_head">Strategic Accounts</h5>
            <p className="strategic_accounts_para">
              Highlight key strategic accounts for Siemens. Includes logos, deal
              highlights, and business importance to indicate account strength
              and footprint.
            </p>
          </div>
          <div className="strategic_accounts_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="strategic_accounts">
              <div className="strategic_accounts_subblock">
                <div className="strategic_accounts_alert_block">
                  <div className="strategic_accounts_icon_block">
                    <img
                      src="/img/siemens.png"
                      className="icon_link"
                      alt="icon"
                    />
                  </div>
                  <div className="strategic_accounts_text_block">
                    <h5 className="strategic_accounts_head">Shell</h5>
                    <div className="strategic_accounts_bottom_block">
                      <div className="strategic_accounts_bottom_left">
                        <p className="strategic_accounts_text_para">$ 50M</p>
                        <p className="comp_dot">•</p>
                        <p className="strategic_accounts_text_para">
                          Energy Infra
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="strategic_accounts">
              <div className="strategic_accounts_subblock">
                <div className="strategic_accounts_alert_block">
                  <div className="strategic_accounts_icon_block">
                    <img
                      src="/img/siemens.png"
                      className="icon_link"
                      alt="icon"
                    />
                  </div>
                  <div className="strategic_accounts_text_block">
                    <h5 className="strategic_accounts_head">Shell</h5>
                    <div className="strategic_accounts_bottom_block">
                      <div className="strategic_accounts_bottom_left">
                        <p className="strategic_accounts_text_para">$ 50M</p>
                        <p className="comp_dot">•</p>
                        <p className="strategic_accounts_text_para">
                          Energy Infra
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="strategic_accounts">
              <div className="strategic_accounts_subblock">
                <div className="strategic_accounts_alert_block">
                  <div className="strategic_accounts_icon_block">
                    <img
                      src="/img/siemens.png"
                      className="icon_link"
                      alt="icon"
                    />
                  </div>
                  <div className="strategic_accounts_text_block">
                    <h5 className="strategic_accounts_head">Shell</h5>
                    <div className="strategic_accounts_bottom_block">
                      <div className="strategic_accounts_bottom_left">
                        <p className="strategic_accounts_text_para">$ 50M</p>
                        <p className="comp_dot">•</p>
                        <p className="strategic_accounts_text_para">
                          Energy Infra
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="strategic_accounts">
              <div className="strategic_accounts_subblock">
                <div className="strategic_accounts_alert_block">
                  <div className="strategic_accounts_icon_block">
                    <img
                      src="/img/siemens.png"
                      className="icon_link"
                      alt="icon"
                    />
                  </div>
                  <div className="strategic_accounts_text_block">
                    <h5 className="strategic_accounts_head">Shell</h5>
                    <div className="strategic_accounts_bottom_block">
                      <div className="strategic_accounts_bottom_left">
                        <p className="strategic_accounts_text_para">$ 50M</p>
                        <p className="comp_dot">•</p>
                        <p className="strategic_accounts_text_para">
                          Energy Infra
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <TopCustomers /> */}

      {showScrollTop && (
        <button className="scroll-top-btn" onClick={scrollToTop}>
          {/* ↑ */}
          <FeatherIcon.ChevronUp className="icon" />
        </button>
      )}

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={""} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default Marketing;
